function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 162",
    d: "M20 12v10H4V12",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 265",
    transform: "translate(2 7)",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0h20v5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    transform: "translate(12 7)",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 15V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 163",
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 164",
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z",
    style: {
      fill: "none",
      stroke: "#6c7b8b",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.2bb9323a86a4391b7dc179bbb5baaef7.svg";
export { ForwardRef as ReactComponent };